import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "../../assets/css/agent/user-timeline.scss";
import FeaturesTab from "../../components/FeaturesTab";
import LeftBar from "../../components/LeftBar";
import RightBar from "../../components/RightBar";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { RiMessage3Fill } from "react-icons/ri";
import AvatarGirl from "../../assets/images/avatar.png";
import SlideUp from "../../assets/images/slide-up.png";
import axiosInstance from "../../environment/axiosInstance";
import moment from "moment";
import ReactPaginate from 'react-paginate';
import "../../assets/css/pagination.scss";

function UserConversations() {
    const { userId } = useParams();
    const [dateRangeClicked, setDateRangeClicked] = useState(false);
    const [chats, setChats] = useState([]);

    useEffect(() => {
        axiosInstance
            .get(process.env.REACT_APP_API_URL + "/support/business_owner/customer/" + userId)
            .then(response => {
                if (response.data.statusCode == 200) {
                    var user_tabs = JSON.parse(localStorage.getItem("user_tabs"));

                    if (!user_tabs) {
                        var user_tab = {
                            id: userId,
                            name: response.data.Data?.customer_name,
                            email: response.data.Data?.customer_email
                        };

                        localStorage.setItem("user_tabs", JSON.stringify([user_tab]));
                    }
                    else {
                        var tab_exists = user_tabs.filter(tab => tab.id == userId);

                        if (!tab_exists.length) {
                            var user_tab = {
                                id: userId,
                                name: response.data.Data?.customer_name,
                                email: response.data.Data?.customer_email
                            };

                            user_tabs.push(user_tab);

                            localStorage.setItem("user_tabs", JSON.stringify(user_tabs));
                        }
                    }
                }
            });
    }, []);

    useEffect(() => {
        axiosInstance
            .get(process.env.REACT_APP_API_URL + "/support/business_owner/chat/customer/" + userId)
            .then(response => {
                if (response.data.statusCode == 200) {
                    console.log("chats here ", response.data.Data);
                    setChats(response.data.Data.docs);
                }
            });
    }, [userId]);

    const selectionRange = {
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
    }

    const handleSelect = (ranges) => {
        console.log(ranges);
    }

    return (
        <div>
            {/* <Header />
            <UsersTabs /> */}
            <div className="user-timeline row m-0">
                {/* <div
                    className="p-0 left-col"
                    style={{
                        borderRight: "1px solid #D9D9D9"
                    }}
                >
                    <LeftBar />
                </div> */}
                <div className="p-0 center-col">
                    <FeaturesTab />
                    <div className="timeline-content">
                        {/* <div className="top-bar">
                            <div className="left d-flex align-items-center">
                                <div className="select-date-input">
                                    <div
                                        onClick={() => setDateRangeClicked(!dateRangeClicked)}
                                        className="date-range">
                                        <p className="m-0">22/4/2022 - 27/4/2022</p>
                                        <FaCalendar
                                            className="ms-2"
                                            color="gray"
                                        />
                                    </div>
                                    {
                                        dateRangeClicked ?
                                            <div
                                                className="date-range-picker">
                                                <DateRangePicker
                                                    ranges={[selectionRange]}
                                                    onChange={handleSelect}
                                                />
                                            </div>
                                            :
                                            <></>
                                    }
                                </div>
                                <div className="d-flex align-items-center justify-content-center mx-auto">
                                    <div className="icon-div">
                                        <BsChatLeftTextFill
                                            color="#4d4d4d"
                                        />
                                    </div>
                                    <div className="icon-div">
                                        <FaPhoneAlt
                                            color="#2f6829"
                                        />
                                    </div>
                                    <div className="icon-div">
                                        <RiMessage3Fill
                                            color="#4d4d4d"
                                            size={20}
                                        />
                                    </div>
                                </div>
                                <AiOutlineReload
                                    size={20}
                                    color="#999999"
                                    className="ms-auto cursor-pointer"
                                />
                            </div>
                        </div> */}
                        <div className="timeline-cards">
                            {
                                chats?.map(chat => {
                                    return (
                                        <Link
                                            to={"/ticket/chat/" + chat.customer._id + "?ticketId=" + chat.ticket_id?._id}
                                            style={{
                                                textDecoration: "none"
                                            }}
                                        >
                                            <div className="timeline-card">
                                                <div className="d-flex align-items-center header">
                                                    <img src={SlideUp} width="24" height="24" />
                                                    <p className="m-0 title">Chat from {chat.customer.customer_name}</p>
                                                    <p className="m-0 ms-auto date">{moment(chat.createdAt).format("D-MM-YYYY")}</p>
                                                </div>
                                                <div className="body">
                                                    <div className="notification">
                                                        <div className="d-flex align-items-center">
                                                            <RiMessage3Fill size={20} />
                                                            <p className="m-0 notification-text">Ticket ID # {chat?.ticket_id?.ticket_id}</p>
                                                            {/* <p className="m-0 ms-auto time">9:45 PM</p> */}
                                                        </div>
                                                        {
                                                            chat?.messages?.length ?
                                                                <div className="reply d-flex align-items-center my-1">
                                                                    <img src={AvatarGirl} width="25px" height="25px" />
                                                                    <p className="m-0 notification-text">{chat?.messages[chat?.messages?.length - 1]?.message}</p>
                                                                    <p className="m-0 ms-auto time">{chat?.messages[chat?.messages?.length - 1]?.createdAt?.split("T")[0]}</p>
                                                                </div>
                                                                :
                                                                <></>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    )
                                })
                            }
                            {/* <div className="timeline-card">
                                <div className="d-flex align-items-center header">
                                    <img src={SlideDown} width="24" height="24" />
                                    <p className="m-0 title">Messages from Asad</p>
                                    <p className="m-0 ms-auto date">22-4-2022</p>
                                </div>
                            </div>
                            <div className="timeline-card">
                                <div className="d-flex align-items-center header">
                                    <img src={SlideUp} width="24" height="24" />
                                    <p className="m-0 title">Messages from Asad</p>
                                    <p className="m-0 ms-auto date">22-4-2022</p>
                                </div>
                                <div className="body">
                                    <div className="notification d-flex align-items-center">
                                        <RiMessage3Fill size={20} />
                                        <p className="m-0 notification-text">Please  check my account details its not working right</p>
                                        <p className="m-0 ms-auto time">9:45 PM</p>
                                    </div>
                                    <div className="notification d-flex align-items-center">
                                        <RiMessage3Fill size={20} />
                                        <p className="m-0 notification-text">Please  check my account details its not working right</p>
                                        <p className="m-0 ms-auto time">9:45 PM</p>
                                    </div>
                                    <div className="notification d-flex align-items-center">
                                        <RiMessage3Fill size={20} />
                                        <p className="m-0 notification-text">Please  check my account details its not working right</p>
                                        <p className="m-0 ms-auto time">9:45 PM</p>
                                    </div>
                                    <div className="notification d-flex align-items-center">
                                        <RiMessage3Fill size={20} />
                                        <p className="m-0 notification-text">Please  check my account details its not working right</p>
                                        <p className="m-0 ms-auto time">9:45 PM</p>
                                    </div>
                                </div>
                            </div>
                            <div className="timeline-card">
                                <div className="d-flex align-items-center header">
                                    <img src={SlideUp} width="24" height="24" />
                                    <p className="m-0 title">Messages from Asad</p>
                                    <p className="m-0 ms-auto date">22-4-2022</p>
                                </div>
                                <div className="body">
                                    <div className="notification d-flex align-items-center">
                                        <RiMessage3Fill size={20} />
                                        <p className="m-0 notification-text">Please  check my account details its not working right</p>
                                        <p className="m-0 ms-auto time">9:45 PM</p>
                                    </div>
                                    <div className="notification d-flex align-items-center">
                                        <RiMessage3Fill size={20} />
                                        <p className="m-0 notification-text">Please  check my account details its not working right</p>
                                        <p className="m-0 ms-auto time">9:45 PM</p>
                                    </div>
                                    <div className="notification d-flex align-items-center">
                                        <RiMessage3Fill size={20} />
                                        <p className="m-0 notification-text">Please  check my account details its not working right</p>
                                        <p className="m-0 ms-auto time">9:45 PM</p>
                                    </div>
                                    <div className="notification d-flex align-items-center">
                                        <RiMessage3Fill size={20} />
                                        <p className="m-0 notification-text">Please  check my account details its not working right</p>
                                        <p className="m-0 ms-auto time">9:45 PM</p>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
                <div
                    className="p-0 right-col"
                    style={{
                        borderLeft: "1px solid #D9D9D9"
                    }}
                >
                    <RightBar />
                </div>
            </div>
        </div>
    )
}

export default UserConversations;